import { Component, EventEmitter, Input, OnInit, OnDestroy, ViewChild, ElementRef, AfterViewInit } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { Subscription } from 'rxjs';
import { IFieldConfig } from 'src/app/domain/IFieldConfig';
import { TypeCesEnum } from 'src/app/domain/registration/enums/type-ces.enum';
import { KeyboardService } from '../../keyboard/keyboard.service';

@Component({
    selector: 'app-input-cellphone-area-code',
    templateUrl: './input-cellphone-area-code.component.html',
    styleUrls: ['./input-cellphone-area-code.component.sass'],
})
export class InputCellPhoneAreaCodeComponent implements OnInit, OnDestroy {
    @Input()
    config: IFieldConfig;
    @Input()
    group: FormGroup;
    @Input()
    typeCes?: TypeCesEnum | undefined;

    // Remover ViewChild se não for mais necessário
    // @ViewChild('input') inputElementRef: ElementRef<HTMLInputElement>;

    private keyboardSubscription: Subscription;

    constructor(public keyboardService: KeyboardService) { }

    ngOnInit(): void {
        // Restaurar a definição de valor padrão
        const control = this.group.get(this.config.name);
        if (control && !control.value) {
            // Define apenas os dígitos; ngx-mask formatará para +55
            control.setValue('55');
        }

        this.keyboardSubscription = this.keyboardService.keyboardOnInputChange.subscribe((event: string) => {
            this.handleVirtualKeyboardInput(event);
        });
    }

    ngOnDestroy(): void {
        if (this.keyboardSubscription) {
            this.keyboardSubscription.unsubscribe();
        }
    }

    /**
     * Simplificado: Atualiza o valor do FormControl (não mascarado)
     * e deixa o ngx-mask cuidar da exibição.
     */
    private handleVirtualKeyboardInput(keyboardEvent: string): void {
        const control = this.group.get(this.config.name);
        if (!control) {
            return;
        }

        let currentValueUnmasked: string = control.value || '';

        if (keyboardEvent === 'Backspace') {
            if (currentValueUnmasked.length > 0) {
                currentValueUnmasked = currentValueUnmasked.slice(0, -1);
            }
        } else if (keyboardEvent === '+' && currentValueUnmasked.length === 0) {
            // Adiciona '+' ao valor não mascarado apenas se for o primeiro caractere.
            // É importante notar que o ngx-mask pode ou não manter isso 
            // no control.value dependendo da máscara exata e dropSpecialCharacters.
            // Se o '+' não for desejado no valor final, esta linha pode ser removida.
            currentValueUnmasked = '+';
        } else if (/\d/.test(keyboardEvent)) {
            // Adiciona apenas dígitos ao valor não mascarado.
            currentValueUnmasked += keyboardEvent;
        }
        // Ignora outros caracteres vindos do teclado virtual.

        // Define o novo valor NÃO MASCARADO no controle.
        // Ngx-mask detectará essa mudança e atualizará a view (input.value) com a máscara.
        control.setValue(currentValueUnmasked);
    }
}
